// #region License

/**
 * @license
 * Copyright (C) Mairistem
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * Proprietary and confidential
 */

// #endregion

import * as React from "react";
import * as ReactDom from "react-dom";
import { createBrowserHistory } from "history";
import { useWindow } from "@jvs-group/jvs-mairistem-tools";
import Application from "../Application";
import { storeManager } from "../../services/redux";
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
export const ApplicationWindow = props => {
  const {
    children,
    path
  } = props;
  const [history, setHistory] = React.useState();
  const [open, setOpen] = React.useState(false);
  const [ready, setReady] = React.useState(false);
  const [window, container, load] = useWindow(path, open);
  const handleOpen = React.useCallback(() => {
    React.startTransition(() => {
      setOpen(true);
    });
  }, []);
  React.useEffect(() => {
    if (window) {
      React.startTransition(() => {
        setHistory(createBrowserHistory({
          window
        }));
      });
    }
  }, [window]);
  React.useEffect(() => {
    if (!load) {
      React.startTransition(() => {
        setOpen(false);
      });
    }
  }, [load]);
  React.useEffect(() => {
    React.startTransition(() => {
      setReady(open && !!window && !!container && !!history);
    });
  }, [window, container, history, open]);
  const content = React.useMemo(() => /*#__PURE__*/_jsx(Application, {
    history: history,
    store: storeManager.store
  }), [history]);
  const portal = React.useMemo(() => ready && /*#__PURE__*/ReactDom.createPortal(content, container), [ready, content, container]);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [children({
      onOpen: handleOpen
    }), portal]
  });
};